import React from "react";
import styles from "./NotFoundPage.module.css";
import errorImg from "../../../img/404-pages.jpg";

const NotFoundPage = () => {
  return (
    <div className="container ">
      <div className={styles.errorImg}>
        <img src={errorImg} alt="" className="img-fluid" />
      </div>
    </div>
  );
};

export default NotFoundPage;
